<template>
  <div>
    <PopUp
      @close="$emit('close')"
      :title="$t('subscribe_period.title')"
      v-if="!changingCard"
    >
      <div>
        <div class="subscription-pop-up-container" v-show="!changingCard">
          <SubscriptionPriceCard
            @select="selected_periodicity = 'month'"
            :active="selected_periodicity == 'month'"
            :length="1"
            @subscribe="proceedToPayment"
            :profit="0"
            :month_price="subscription.price"
          />
          <SubscriptionPriceCard
            @select="selected_periodicity = 'year'"
            :month_price="Math.floor(subscription.price * 0.8)"
            :active="selected_periodicity == 'year'"
            @subscribe="proceedToPayment"
            :profit="Math.floor(subscription.price * 12 * 0.2)"
            :length="12"
          />
        </div>
      </div>
    </PopUp>
    <form
      method="POST"
      action="https://www.liqpay.ua/api/3/checkout"
      accept-charset="utf-8"
      ref="subscribeForm"
      v-show="false"
    >
      <input type="hidden" name="data" :value="subscribe_form.data" />
      <input type="hidden" name="signature" :value="subscribe_form.signature" />
    </form>
  </div>
</template>

<script>
import SubscriptionPriceCard from "@/components/subscriptions/SubscriptionPriceCard.vue";

import PopUp from "@/components/PopUp.vue";

import SubscriptionAPI from "@/api/subscription";

export default {
  data() {
    return {
      subscribe_form: {
        data: null,
        signature: null,
      },

      selected_periodicity: "month",
    };
  },
  props: {
    mode: String,
    changingCard: Boolean,
  },
  methods: {
    proceedToPayment() {
      SubscriptionAPI.generateForm(
        this.subscription._id,
        this.selected_periodicity,
        this.changingCard
      )
        .then((data) => {
          this.subscribe_form = data.form;

          this.$nextTick(() => {
            setTimeout(() => {
              this.$refs.subscribeForm.submit();
            }, 500);
          });
        })
        .catch((error) => {
          this.$store.dispatch("showError", "subscription_error");
        });
    },
  },
  mounted() {
    if (this.changingCard) {
      this.selected_periodicity = this.subscription.periodicity;
      this.proceedToPayment();
    }
  },
  components: {
    SubscriptionPriceCard,
    PopUp,
  },
  computed: {
    subscription() {
      return this.$store.getters["subscriptions/all"][this.mode];
    },
  },
};
</script>

<style scoped>
.subscription-pop-up-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  margin-top: 5.555555555555555vh;
}
</style>